export const ChevronProgressSectionUp = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 10.5L8 6.5L4 10.5" stroke="#4A5466" strokeMiterlimit="16" />
  </svg>
);
